/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Diff_Type_AddedInputs */

const en_compare_event_groups_diff_type_added = /** @type {(inputs: Compare_Event_Groups_Diff_Type_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`added`)
};

const fr_compare_event_groups_diff_type_added = /** @type {(inputs: Compare_Event_Groups_Diff_Type_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ajouté`)
};

const de_compare_event_groups_diff_type_added = /** @type {(inputs: Compare_Event_Groups_Diff_Type_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hinzugefügt`)
};

const it_compare_event_groups_diff_type_added = /** @type {(inputs: Compare_Event_Groups_Diff_Type_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aggiunto`)
};

const ru_compare_event_groups_diff_type_added = /** @type {(inputs: Compare_Event_Groups_Diff_Type_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`добавлен`)
};

const es_compare_event_groups_diff_type_added = /** @type {(inputs: Compare_Event_Groups_Diff_Type_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`agregado`)
};

const zh_cn2_compare_event_groups_diff_type_added = /** @type {(inputs: Compare_Event_Groups_Diff_Type_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`额外`)
};

const ja_compare_event_groups_diff_type_added = /** @type {(inputs: Compare_Event_Groups_Diff_Type_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加した`)
};

const hi_compare_event_groups_diff_type_added = /** @type {(inputs: Compare_Event_Groups_Diff_Type_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जोड़ा`)
};

const pt_pt2_compare_event_groups_diff_type_added = /** @type {(inputs: Compare_Event_Groups_Diff_Type_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`adicionado`)
};

/**
* | output |
* | --- |
* | "added" |
*
* @param {Compare_Event_Groups_Diff_Type_AddedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_diff_type_added = /** @type {((inputs?: Compare_Event_Groups_Diff_Type_AddedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Diff_Type_AddedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_diff_type_added(inputs)
	if (locale === "de") return de_compare_event_groups_diff_type_added(inputs)
	if (locale === "it") return it_compare_event_groups_diff_type_added(inputs)
	if (locale === "ru") return ru_compare_event_groups_diff_type_added(inputs)
	if (locale === "es") return es_compare_event_groups_diff_type_added(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_diff_type_added(inputs)
	if (locale === "ja") return ja_compare_event_groups_diff_type_added(inputs)
	if (locale === "hi") return hi_compare_event_groups_diff_type_added(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_diff_type_added(inputs)
	return en_compare_event_groups_diff_type_added(inputs)
});